export const faq = [
  {
    question: "Atendem emergência veterinária 24 horas em Lages – SC?",
    answer:
      "Sim. Nossa equipe atende urgência e emergência 24h, todos os dias. Em casos críticos — como vômitos persistentes, convulsões, trauma ou dificuldade para respirar — ligue imediatamente para (49) 99982-7046."
  },
  {
    question: "Fazem exames como raio-X e ultrassom?",
    answer:
      "Sim. Realizamos diagnósticos por imagem (raio-X e ultrassom), além de exames laboratoriais com resultados rápidos para apoiar decisões clínicas e cirúrgicas."
  },
  {
    question: "Realizam cirurgias? Como é o pós-operatório?",
    answer:
      "Sim, realizamos cirurgias de baixa e média complexidade, com protocolos de segurança e anestesia. No pós-operatório, orientamos medicação, curativos e retorno, e quando necessário oferecemos internamento para monitoramento."
  },
  {
    question: "Quais vacinas são exigidas para hospedagem ou day care?",
    answer:
      "Pedimos vacinação em dia (como V8/V10, antirrábica e, conforme o caso, tosse dos canis), além de controle de pulgas e carrapatos. A equipe confere a carteirinha na chegada."
  },
  {
    question: "Quanto custa a consulta veterinária?",
    answer:
      "O valor pode variar conforme o horário (plantão 24h) e complexidade do caso. Entre em contato para orçamento atualizado; após a anamnese, solicitamos exames apenas quando realmente necessários."
  }
]